const reducers = {
  appGetBraintreeTokenSuccess: (app, payload: { token: string }) => ({
    ...app,
    braintreeAccessToken: payload.token
  }),

  appGetPlaidTokenLoading: app => ({
    ...app,
    plaidLinkLoading: true
  }),

  appGetPlaidTokenSuccess: (app, payload: { plaidLinkToken: string }) => ({
    ...app,
    plaidLinkToken: payload.plaidLinkToken,
    plaidLinkLoading: false
  }),

  appQueryGetInitialFundingSuccess: (
    app,
    payload: { achDisabledMessage?: string }
  ) => ({
    ...app,
    achError: !!payload.achDisabledMessage,
    achMessage: payload.achDisabledMessage
  }),

  appVerifyDebitNowSuccess: userStore => ({
    ...userStore,
    needsVerification: false
  }),

  appVerifyDebitNowFailure: (app, payload: { response?: any }) => ({
    ...app,
    errorCode: payload.response ? payload.response.data.code : ''
  }),

  verifyDebitLater: app => ({
    ...app,
    message: '',
    error: false,
    errorCode: false,
    needsVerification: true,
    skippedVerification: true
  }),

  // async logic passthrough reducers
  getBankName: (
    app,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    payload: { routingNumber: string }
  ) => app,

  getBraintreeToken: app => app,

  getFundingAccounts: app => app,

  getMicrodeposits: (
    app,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    payload: {
      fundingAccountId: string;
      fundingType: string;
    }
  ) => app,

  getPlaidToken: (
    app,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    payload: {
      platform: string;
    }
  ) => app,

  queryGetInitialFunding: app => app,

  verifyDebitNow: (
    app,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    payload: {
      instantFundingAccountId: string;
      amount1: number;
      amount2: number;
    }
  ) => app
};

export default { ...reducers };
